import { render, staticRenderFns } from "./deInforSett.vue?vue&type=template&id=e6a7a224&scoped=true&"
import script from "./deInforSett.vue?vue&type=script&lang=js&"
export * from "./deInforSett.vue?vue&type=script&lang=js&"
import style0 from "./deInforSett.vue?vue&type=style&index=0&id=e6a7a224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a7a224",
  null
  
)

export default component.exports